export default __webpack_public_path__ + "static/media/gold.21c0f095.png";